module.exports = __webpack_public_path__ + "media/images/flags/64/Gabon-74db2372652a210f152916e58be9328f.png";